/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Note_Error_Not_Logged_InInputs */

const en_toast_note_error_not_logged_in = /** @type {(inputs: Toast_Note_Error_Not_Logged_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error adding audio note, not logged in`)
};

const es_toast_note_error_not_logged_in = /** @type {(inputs: Toast_Note_Error_Not_Logged_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al agregar nota de audio, no has iniciado sesión`)
};

/**
* | output |
* | --- |
* | "Error adding audio note, not logged in" |
*
* @param {Toast_Note_Error_Not_Logged_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_note_error_not_logged_in = /** @type {((inputs?: Toast_Note_Error_Not_Logged_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Note_Error_Not_Logged_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_note_error_not_logged_in(inputs)
	return en_toast_note_error_not_logged_in(inputs)
});